const coinPaymentModalStyles = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-white max-w-[400px] text-black p-[25px] min-w-[300px]`,
    innerContainer: `flex flex-col gap-[20px] items-center justify-center`,
    thankYouText: `text-center text-[27px] font-Suisse text-paymentSuccess`,
    thankYouTextError: `text-center text-[27px] font-Suisse text-paymentError`,
    thankYouMessage: `text-center text-black text-[16px] capitalize`,
    thankYouMessageError: `text-center text-paymentError text-[16px] capitalize`,
    message: `text-center text-[16px]`,
    doneIcon: `flex justify-center items-center rounded-[50%] p-[10px]`,
 }
 
 export  { coinPaymentModalStyles }